import { Link } from 'react-router-dom';

// Compact user identifier used everywhere a row references a user. Clicks
// through to /admin/users/:id so the operator can drill in from any context.
export function UserChip({ userId, displayName, avatarUrl, className = '' }) {
  if (!userId) return null;
  const label = displayName || userId.slice(0, 8);
  return (
    <Link
      to={`/admin/users/${userId}`}
      className={`inline-flex items-center gap-2 group ${className}`}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          className="w-6 h-6 rounded-full bg-stone-200 object-cover"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-stone-200 flex items-center justify-center text-[10px] text-stone-600">
          {label.slice(0, 2).toUpperCase()}
        </div>
      )}
      <span className="text-sm text-stone-800 group-hover:underline truncate">
        {label}
      </span>
    </Link>
  );
}
